<template>
  <div class="card my-3 mx-2">
    <div class="form-group and-or-rule m-0 p-2">
      <div class="d-flex flex-nowrap">
        <div class="d-flex flex-column justify-content-center pr-2 handle mx-1">
          <icon name="th" />
        </div>

        <div class="mx-1">
          <select
            class="form-control input-sm"
            v-model="key"
            @change="changedKey">
            <option
              v-for="(option, index) in options.keys"
              :key="index"
              :value="option.id">
              {{option.name}}
            </option>
          </select>
        </div>

        <div v-if="enableRuleName" class="mx-1">
          <input
            type="text"
            class="form-control input-sm"
            v-model="name"
            placeholder="Rule name"
            @change="changedRule" />
        </div>

        <b-form-checkbox
          v-if="isHidable"
          class="pull-left and-or-rule__hidden mx-1"
          v-model='hidden'
          @change="changedRule">
          hidden
        </b-form-checkbox>

        <div v-show="operatorsOptions.length > 1" class="mx-1">
          <select
            class="form-control input-sm"
            v-model="operator"
            @change="changedOperator">
            <option
              v-for="(option, index) in operatorsOptions"
              :key="index"
              :value="option.id">
              {{option.name}}
            </option>
          </select>
        </div>

        <div v-if="key != -1" class="mx-1 d-flex">
          <label class="sr-only">value</label>
          <input
            v-if="isExpressionMode"
            class="form-control input-sm"
            v-model="value"
            @change="changedRuleValue(value)"
            placeholder="Expression" />
          <RuleValue
            v-else
            :ruleValue="value"
            :ruleOperator="operator"
            :ruleKey="key"
            :ruleHasExpression="key"
            :dataProvider="options.dataProvider"
            :isComputedExpression="isComputedExpression"
            @change="changedRuleValue($event)"
          />
          <button
            v-if="isComputedExpression && keyType !== 'date' && keyType !== 'checkbox'"
            class="btn btn-sm btn__toggle-expression"
            :class="{ 'btn-primary': isExpressionMode }"
            @click="toggleExpression()">
            <icon name="code" />
          </button>
        </div>

        <button class="btn btn-sm btn-purple pull-right mx-1" @click.prevent="deleteSelf()">
          x
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import db from '@/services/db'
import RuleValue from './RuleValue'

export default {
  name: 'rule',
  props: ['options', 'rule', 'enableRuleName', 'isComputedExpression', 'isHidable'],
  components: {
    RuleValue
  },
  watch: {
    'options.keys.options' () {
      this.key = -1;
    },
    'options.conditions.options' () {
      this.condition = -1;
    }
  },
  data () {
    return {
      key: -1,
      operator: -1,
      value: null,
      name: null,
      keyType: null,
      hidden: false,
      operatorsOptions: [],
      isExpressionMode: false
    }
  },
  mounted() {
    if (this.rule) {
      this.key = this.rule.key || this.key
      this.operator = this.rule.operator || this.operator
      this.value = this.rule.value;
      this.name = this.rule.name || this.name;
      this.hidden = !!this.rule.hidden;
      this.isExpressionMode = this.isComputedExpression && this.rule.expression;

      this.updateKeyType();
      this.updateOperatorsOptions();
    }
  },
  computed: {
    ...mapState([
      "dataGrid_options"
    ])
  },
  methods: {
    deleteSelf () {
      this.$emit('delete-rule')
    },
    queryFormStatus () {
      return {
        key: this.key,
        operator: this.operator,
        value: this.value,
        name: this.name || this.key,
        expression: this.isExpressionMode,
        hidden: this.hidden
      }
    },
    changedRuleValue(value) {
      this.value = value;
      this.changedRule();
    },
    changedKey() {
      this.updateKeyType()
      this.updateOperatorsOptions();
      this.operator = this.operatorsOptions[0].id;
      this.value = null;
      this.changedRule()
    },
    changedOperator() {
      this.value = null;
      this.changedRule()
    },
    changedRule() {
      this.$emit('change-rule')
    },
    updateKeyType() {
      this.keyType = null;
      if(this.key) {
        const options = this.dataGrid_options[this.options.dataProvider] || {}
        const meta = (options.meta && options.meta[this.key]) || {}
        this.keyType = meta.type;
      }
    },
    updateOperatorsOptions() {
      if (this.keyType) {
        this.operatorsOptions = this.options.operators.filter((o) => {
          if(o.onlyFor) {
            return o.onlyFor.includes(this.keyType)
          }

          if (o.except) {
            return !o.except.includes(this.keyType);
          }

          return true
        });
      }
    },
    toggleExpression() {
      this.isExpressionMode = !this.isExpressionMode;
      this.changedRuleValue();
    }
  }
}
</script>

<style lang="scss">
  .handle {
    font-size: 1.4rem;
    color: #c0c5e2;
    cursor: move;
  }

  .card {
    box-shadow: 0 .25rem 0.5rem 0 rgba(136, 152, 170, .15);
  }

  .and-or-rule {
    position: relative;

    &__hidden {
      margin-top: 10px;
    }
  }
</style>
